/* global axios */
import ApiClient from './ApiClient';

class SchedulingPagesAPI extends ApiClient {
  constructor() {
    super('scheduling_pages', { accountScoped: true });
  }

  // Todas as agendas ATIVAS da conta (só administrador). A listagem normal é
  // por dono, e o formulário precisa poder apontar para a agenda de outra
  // pessoa da equipe.
  allOfAccount() {
    return axios.get(this.url, { params: { all: true } });
  }

  // Duração padrão da CONTA (regra da agenda) — a lista acima é por dono.
  defaults() {
    return axios.get(`${this.url}/defaults`);
  }

  create(page) {
    return axios.post(this.url, { scheduling_page: page });
  }

  update(id, page) {
    return axios.patch(`${this.url}/${id}`, { scheduling_page: page });
  }
}

export default new SchedulingPagesAPI();
